import React from 'react';
import config from 'react-global-configuration';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Card } from '../../../../components';

const ExpertContent = ({ entities, args, onLoadMore }) => {
  const { t } = useTranslation();
  const currentPage = useSelector((state) => state.getIn(['view', 'expert_content', 'block_1', 'pager', 'current_page'], 0));
  const totalPages = useSelector((state) => state.getIn(['view', 'expert_content', 'block_1', 'pager', 'total_pages'], 0));
  const morePages = currentPage < totalPages - 1;

  if (!entities) {
    return null;
  }

  return (
    <div className="row">
      {
        entities.map((item) => {
          const title = item.getIn(['title', 0, 'value']);
          const image = item.getIn(['field_media_image', 0, 'styles', '1_1'], null);
          const imageAlt = item.getIn(['field_media_image', 0, 'alt'], '');
          const language = config.get('DEFAULT_LANGUAGE');
          const type = item.getIn(['type', 0, 'target_id'], null);
          const subType = item.getIn(['field_article_type', 0, 'entity', 'name', 0, 'value'],
            item.getIn(['field_research_type', 0, 'entity', 'name', 0, 'value'],
              item.getIn(['field_intervention_type', 0, 'entity', 'name', 0, 'value'],
                item.getIn(['type', 0, 'target_id']))));
          const url = item.getIn(['paths', language], item.get('paths').first());
          const uuid = item.getIn(['uuid', 0, 'value']);

          return (
            <div key={uuid} className="NodeExpertDetail__get_started__content__card col-12 col-md-6 col-xl-4">
              <Card small title={title} image={image} alt={imageAlt} type={type} link={url} subType={subType} />
            </div>
          );
        })
      }

      {morePages &&
        <div className="col-12 LoadMore">
          <a className="Button Button--ghost" onClick={onLoadMore}>{t('expert.show_more')} <i className="icon icon-arrow-right icon-variant-2" /></a>
        </div>}
    </div>
  );
};

export default ExpertContent;
